<template>
    <div class="mobile-common-menu mobile-common-menu--auth" :class="{'mobile-common-menu--open': commonFavoritesMenu}">
        <template v-if="commonFavoritesMenu">
            <div class="mobile-common-menu__container js-mobile-menu-container">
                <div class="mobile-common-menu__container-inner">
                    <div class="mobile-common-menu__content">
                        <ul class="mobile-common-menu__links">
                            <li class="mobile-menu__link" v-for="(favorite, i) in favorites" :key="i">
                                <a href="#" @click.prevent="goTo(favorite)">
                                    {{ favorite.albumTitle || $t('no_name') }}<template v-if="!!favorite.items.length">({{ favorite.items.length }})</template>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_COMMON_FAVORITES_MENU', false)" class="mobile-common-menu__btn -red">
                <span class="material-icon icon-clear"/>
            </a>
        </template>
        <a v-else href="#" class="action-link" @click.prevent="$store.dispatch('SET_MOBILE_COMMON_FAVORITES_MENU', true)">
            <span class="material-icon icon-library_add"/>
            <span class="action-link__txt">{{ $t('selected') }}</span>
            <span v-if="!!favoritesLength" class="badge badge-success">{{ favoritesLength }}</span>
        </a>
    </div>
</template>

<script>
  import MobileCommonFavoritesMenu from 'src/mixins/mobileCommonFavoritesMenuComponent';

  export default {
    mixins: [MobileCommonFavoritesMenu],
  };
</script>
